import { render, staticRenderFns } from "./RelatorioSaidaMensalAdm.vue?vue&type=template&id=3ada1022"
import script from "./RelatorioSaidaMensalAdm.vue?vue&type=script&lang=js"
export * from "./RelatorioSaidaMensalAdm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports